import { DegreeTypeText } from '../../../keyword-helper/enums/DegreeTypeText';
import { KeywordHelperType } from '../../../keyword-helper/enums/KeywordHelperType';
import { KeywordHelperContent } from '../../../keyword-helper/KeywordHelperContent';

class WrongPortalPhdDefinition extends KeywordHelperContent {
	public constructor() {
		super(KeywordHelperType.WRONG_PORTAL, DegreeTypeText.PHD, 'https://www.phdportal.com', 'PhDportal.com');
	}
}

export default new WrongPortalPhdDefinition();
